import {Grid, type Integer, type ValueByDevice} from 'platform/foundation';

import {use} from 'react';

import {CHART_SUMMARY_COLUMNS} from '../../constants/CHART_SUMMARY_COLUMNS';
import {ChartCardContext} from '../../contexts/ChartCardContext';
import {ChartSummaryCard} from '../ChartSummaryCard/ChartSummaryCard';

interface ChartSummaryCardItem {
  id: string;
  label: string;
  /** Formatted summary value, for example a total for the selected period. */
  value: string;
  /** Formatted rate shown in a flag after the value, for example its share of the total. */
  rate?: string;
}

interface ChartSummaryCardsProps {
  items: ChartSummaryCardItem[];
  /**
   * Cards per row by device, for a chart card outside a chart grid that is not full width.
   * Defaults to the columns of the chart card width.
   */
  columns?: ValueByDevice<Integer>;
  /** Less padding and a smaller value, for a chart card with little room. */
  isCompact?: boolean;
}

/**
 * Summary values of a chart that has nothing to show or hide, on grey cards. A chart whose
 * series can be switched uses `ChartSummaryToggles` instead.
 */
export function ChartSummaryCards(props: ChartSummaryCardsProps) {
  const cardWidth = use(ChartCardContext)?.width ?? 'full';

  return (
    <Grid columns={props.columns ?? CHART_SUMMARY_COLUMNS[cardWidth]} spacing={4}>
      {props.items.map((item) => (
        <ChartSummaryCard
          key={item.id}
          label={item.label}
          value={item.value}
          rate={item.rate}
          isCompact={props.isCompact}
        />
      ))}
    </Grid>
  );
}
